import { IconZoomOut } from "@suse-o11y/icons";
import { type Signal, useMonitor } from "@suse-o11y/signal";
import React from "react";

import type { TimeRange } from "../../../../app/state/view/timeline/TimeRange";
import { IconButton, type IconButtonSize } from "../Buttons";

export interface ZoomOutProps {
	className?: string;
	timeRange: Signal<TimeRange>;
	size?: IconButtonSize;
	contextName: string;
	disabled?: boolean;
}

export const ZoomOut: React.FC<ZoomOutProps> = ({ timeRange, contextName, disabled = false, ...props }) => {
	const monitor = useMonitor();

	return (
		<IconButton
			data-testid="timeline-zoom-out"
			disabled={disabled || !timeRange.read(monitor).isLessLimit()}
			icon={<IconZoomOut className="text-xs/[23px]" />}
			onClick={() => timeRange.write((current) => current.zoomOut())}
			size="middle"
			tooltip={`Zoom-out of the current ${contextName} interval (max. 6 months)`}
			{...props}
		/>
	);
};
